import { render } from "./Import_Historical_Loans.vue?vue&type=template&id=362d83b4"
import script from "./Import_Historical_Loans.vue?vue&type=script&lang=js"
export * from "./Import_Historical_Loans.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__